import { addDays, format, startOfWeek } from 'date-fns';
import { pipe } from 'fp-ts/function';
var dayOfWeekMap = {
  Sun: 0,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6
};
export var isDayOfWeek = function isDayOfWeek(dayOfWeek) {
  return Object.keys(dayOfWeekMap).includes(dayOfWeek);
};
export var getLocaleDayOfWeek = function getLocaleDayOfWeek(dayOfWeek, locale) {
  return pipe(dayOfWeekMap[dayOfWeek], function (dayInt) {
    return addDays(startOfWeek(new Date()), dayInt);
  }, function (date) {
    return format(date, 'E', {
      locale: locale
    });
  });
};